/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { ReasonsDaoService } from '../reasons-dao.service';
import {
  DbPersistenceService,
  Query
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppConfig } from 'src/app/app.config';
import { Reason } from 'src/app/_model/reason';
import { ReasonDbTableDefinition } from './reason-db-table-definition';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';


@Injectable()
export class ReasonsDbDaoService implements ReasonsDaoService {

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private reasonTableDefinition: ReasonDbTableDefinition,
    private appParameter: AppParameterService,
  ) { }

  public async saveReasons(reasons: Reason[]): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb();

      var reasonsQueries: Query[] = [];
      for (const reason of reasons) {
        let reasonQuery: Query = {
          statement:
            'INSERT OR REPLACE INTO ' +
             this.reasonTableDefinition.tableName +
            '(id, label, databag)' + // 3
            ' VALUES (?,?,?)',
          parameters: [
            Number(reason.isLocal() ? reason.id.secondaryId : reason.id.imsId),
            reason.label,
            reason.databag ? JSON.stringify(reason.databag) : undefined
          ]
        };
        reasonsQueries.push(reasonQuery);
      }
      await this.dbPersistenceService.executeBatch(db, reasonsQueries);
    } catch (error) {
      this.logger.log(
        'Error saving reasons to db',
        error,
        '-',
        error.message
      );
    }
  }

  public async getReasons(): Promise<Reason[]> {
    let db = await this.dbPersistenceService.getImsDb();
    let reasons: Reason[] = [];

    try {
      // Get Synced Reasons
      let data = await this.dbPersistenceService.executeQuery(db, {
        statement: 'SELECT * FROM ' + this.reasonTableDefinition.tableName + ';',
        parameters: null
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        reasons.push(
          Reason.fromDto({
            id: row['id'],
            secondaryid: undefined,
            label: row['label']
          }, 
          row['databag'] ? JSON.parse(row['databag']): undefined,
          this.appParameter.getFormatLabelForObject('ims/Reason'))
        );
      }
    } catch (error) {
      this.logger.log('Error reading reasons from db', error);
    }

    return reasons;
  }

  public async reset() {
    // do nothing
  }

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(this.constructor.name, "truncate table", this.reasonTableDefinition.tableName)
    await this.dbPersistenceService.truncateTable(db, this.reasonTableDefinition.tableName);
  }

}
